import CommentsFields from "./fields";
import CommentsForms from "./forms";
import CommentsHelpers from "./helpers";
import CommentsHooks from "./hooks";


const Comments = {
    Fields: CommentsFields,
    Forms: CommentsForms,
    Helpers: CommentsHelpers,
    Hooks: CommentsHooks,
};

export default Comments;
